import {
  Dialog,
  Divider,
  Typography,
  DialogContent,
  DialogContentText,
  Link,
  Grid,
  useTheme,
} from "@mui/material";
import { FC } from "react";
import CDialogTitle from "components/CDialogTitle";
import CDialogTransition from "components/CDialogTransition";

type DialogProps = {
  open: boolean;
  handleClose: () => void;
};

const CPrivacyDialog: FC<DialogProps> = ({ open, handleClose }) => {
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      maxWidth="lg"
      scroll={"paper"}
      fullWidth={true}
      onClose={handleClose}
      TransitionComponent={CDialogTransition}
      aria-labelledby="customized-dialog-title"
      onClick={(e) => {
        e.stopPropagation();
      }}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 10,
        },
      }}
    >
      <DialogContent>
        <CDialogTitle onClose={handleClose}>Privacy Policy</CDialogTitle>
        <Divider sx={{ marginBottom: 4 }} />
        <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
          <Typography color={theme.palette.text.primary} textAlign={"justify"}>
            <Typography
              variant="h4"
              display={"flex"}
              color={theme.palette.text.primary}
              fontWeight={"bold"}
              justifyContent={"center"}
            >
              NFTYDoor, a division of Homebridge Financial Services, Inc.
              Privacy Policy
            </Typography>
            <br />
            <br /> Homebridge Financial Services, Inc. takes our clients’
            financial privacy very seriously. During the course of processing
            your application, we accumulate non-public personal financial
            information from you and from other sources about your income, your
            assets, and your credit history in order to allow a lender to make
            an informed decision about granting you credit. We restrict access
            to nonpublic personal information about you to those employees who
            need to know that information to provide products or services to
            you. We maintain physical, electronic, and procedural safeguards
            that comply with federal regulations to guard your nonpublic
            personal information.
            <br />
            <br />
            We collect nonpublic information about you from the following
            sources: (i) information we receive from you on applications or
            other forms; (ii) information about your transactions with us, our
            affiliates, or others; and (iii) information we receive from a
            consumer reporting agency.
            <br />
            <br />
            We do not disclose any nonpublic information about our customers or
            former customers to any third party, except as permitted by law.
            <br />
            <br />{" "}
            <Typography variant="h5" color={theme.palette.text.primary}>
              Online Privacy Policy{" "}
            </Typography>
            <br />
            Our Online Privacy Policy explains how we collect, share and use
            information from or about you when you visit or use our website.
            This website is a general audience site and we do not knowingly
            collect personal information from children under the age of 13.
            <br /> By using this website, you agree to the terms and conditions
            of this Online Privacy Policy.
            <br />
            <br />{" "}
            <Typography variant="h5" color={theme.palette.text.primary}>
              Personal information we collect online
            </Typography>
            <br /> You may interact with us in a variety of ways. We may permit
            browsing and not require the inputting of any personal information.
            We may also offer the ability to learn more about or apply for our
            loan products. Information that we may collect about you through
            online interaction includes personal information you provide via a
            contact web-form which includes name, telephone, postal address, and
            email address. If you decide to apply for a loan, other online
            fields will be required such as Social Security Number and
            birthdate.
            <br />
            <br />
            <Typography variant="h5" color={theme.palette.text.primary}>
              How personal information is shared
            </Typography>
            <br />
            We will use and share any information that we collect from or about
            you in accordance with the Homebridge Financial Services Privacy
            Policy, which provides choices in the use and sharing of
            information. This policy can be found{" "}
            <Link
              href="https://www.homebridge.com/wp-content/uploads/2021/03/GLB-Privacy-Policy-rev-3_2021.pdf"
              target="_blank"
            >
              here
            </Link>
            .
            <br />
            <br />
            <Typography variant="h5" color={theme.palette.text.primary}>
              Other information we collect online
            </Typography>
            <br />
            In addition to personal information described above, we may also
            collect and save certain information about your use of our website,
            such as the type of operating system, information about your
            device’s operating system, the browser you are using, the IP address
            of your device and additional information about your device. We or
            our third-party partners may also use cookies and/or tracking pixels
            to collect and store other information about your visit to, or use
            of, our website.
            <br />
            <br />
            “Cookies” are small amounts of data a website can send to a
            visitor’s web browser. They are often stored on the device you are
            using to help track your areas of interest. Cookies we use do not
            contain or capture unencrypted personal information. Cookies allow
            us to collect information such as browser type, time spent on the
            website, and your relationship with us. We use the information for
            security purposes, to facilitate navigation, to display information
            more effectively, to personalize/customize your experience while
            visiting the website, and to recognize your device to allow your use
            of our online products and services. We collect statistical
            information about the usage of the website in order to continually
            improve the design and functionality, to monitor responses to our
            advertisements and content, to understand how visitors use the
            website and to assist us with resolving questions regarding the
            website. We also utilize cookies for our online advertising
            purposes.
            <br />
            <br />
            We do not currently take any action with respect to a browser’s
            “do-not track” signals. If a website visitor enters our website, or
            clicks on one of our advertisements on a third party site, a cookie
            may be planted on the visitor’s browser for future targeted ads.
            <br />
            <br />
            The cookie does not keep a history of which sites were visited, but
            will recognize if the visitor visits a site in the Google Ad
            Network. If the visitor does visit a site on the Google Ad Network
            then the user may be targeted for an advertisement. If a visitor to
            our website enters data into a web-form and submits data to us, the
            information is paired with the IP address of the computer the
            visitor is using. This information is shared internally but not with
            third parties. IP addresses are only shared with the Google search
            company that we use for our ad campaigns.
            <br />
            <br />
            <Typography variant="h5" color={theme.palette.text.primary}>
              Cookie Control
            </Typography>
            <br />
            To prevent or block cookies from tracking your visits, you can
            configure your web browser to reject all cookies, or notify you when
            a cookie is set. Most browsers like Chrome, Safari, Firefox,
            Internet Explorer and more will give you the ability to control and
            block cookies. To learn more or opt-out of receiving online display
            advertisements by our third party partners, visit the Network
            Advertising Initiative at{" "}
            <Link
              href="https://www.networkadvertising.org/choices"
              target="_blank"
            >
              www.networkadvertising.org/choices
            </Link>
            <br />
            <br />{" "}
            <Typography variant="h5" color={theme.palette.text.primary}>
              Security
            </Typography>
            <br /> We maintain physical, electronic and procedural safeguards
            designed to protect personal information. We also employ encryption
            technologies and user authentication procedures that are designed to
            keep your data secure. We limit access to personal information to
            authorized personnel and contractors who need access to perform
            their job and are contractually required to keep your information
            secure.
            <br />
            <br /> Policy updates and effective date
            <br />
            We may make changes to this Online Privacy Policy from time to time.
            In the event of any update, the revised Online Privacy Policy will
            be posted with a new “Last Updated” date. All updates to the Online
            Privacy Policy become effective when we post the updates on our
            website.
            <br />
            <br /> To customize your privacy options with Homebridge, please
            visit our{" "}
            <Link
              href="https://www.homebridge.com/privacychoices/"
              target="_blank"
            >
              Privacy Choices {""}
            </Link>
            page.
            <br />
            <br />
            <Typography variant="h5" color={theme.palette.text.primary}>
              CALIFORNIA CONSUMER PRIVACY ACT NOTICE
            </Typography>
            <br /> Last updated January 1, 2020
            <br /> This PRIVACY NOTICE FOR CALIFORNIA RESIDENTS supplements the
            information contained in the Privacy Policy of Homebridge Financial
            Services, Inc. (collectively, “we,” “us,” or “our”) and applies
            solely to visitors, users, and others who reside in the State of
            California (“consumers” or “you”). We adopt this notice to comply
            with the California Consumer Privacy Act of 2018 (“CCPA”). Any terms
            defined in the CCPA have the same meaning when used in this notice.
            <br />
            <br />
            <Typography variant="h5" color={theme.palette.text.primary}>
              Information We Collect
            </Typography>
            <br />
            We collect information that identifies, relates to, describes,
            references, is reasonably capable of being associated with, or could
            reasonably be linked, directly or indirectly, with a particular
            consumer or device (“personal information”). In particular, we have
            collected the following categories of personal information from
            consumers within the last twelve (12) months*:
            <br />
            <br />
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 2 }}
              justifyContent="center"
            >
              <Grid item xs={6}>
                <Typography
                  textAlign="center"
                  variant="h6"
                  color={theme.palette.text.primary}
                >
                  Categories
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  textAlign="center"
                  variant="h6"
                  color={theme.palette.text.primary}
                >
                  Examples**
                </Typography>
              </Grid>
              <Grid item xs={6}>
                A. Identifiers.
              </Grid>
              <Grid item xs={6}>
                A real name, alias, postal address, unique personal identifier,
                online identifier, Internet Protocol address, email address,
                account name, Social Security number, driver’s license number,
                passport number, or other similar identifiers.
              </Grid>
              <Grid item xs={6}>
                B. Personal information categories listed in the California
                Customer Records statute (Cal. Civ. Code § 1798.80(e)).
              </Grid>
              <Grid item xs={6}>
                A name, signature, Social Security number, physical
                characteristics or description, address, telephone number,
                passport number, driver’s license or state identification card
                number, insurance policy number, education, employment,
                employment history, bank account number, credit card
                number,debit card number, or any other financial information.
                Some personal information included in this category may overlap
                with other categories.
              </Grid>
              <Grid item xs={6}>
                C. Protected classification characteristics under California or
                federal law.
              </Grid>
              <Grid item xs={6}>
                Age (40 years or older), race, color, ancestry, national origin,
                citizenship, religion or creed, marital status, medical
                condition, physical or mental disability, sex (including gender,
                gender identity, gender expression, pregnancy or childbirth and
                related medical conditions), sexual orientation, veteran or
                military status, genetic information (including familial genetic
                information).
              </Grid>
              <Grid item xs={6}>
                D. Commercial information.
              </Grid>
              <Grid item xs={6}>
                Records of personal property, products or services purchased,
                obtained, or considered, or other purchasing or consuming
                histories or tendencies.
              </Grid>
              <Grid item xs={6}>
                E. Internet or other similar network activity.
              </Grid>
              <Grid item xs={6}>
                Browsing history, search history, information on a consumer’s
                interaction with a website, application, or advertisement.
              </Grid>
              <Grid item xs={6}>
                F. Geolocation data.
              </Grid>
              <Grid item xs={6}>
                Physical location or movements.
              </Grid>
              <Grid item xs={6}>
                G. Professional or employment-related information.
              </Grid>
              <Grid item xs={6}>
                Current or past job history or performance evaluations.
              </Grid>
              <Grid item xs={6}>
                H. Non-public education information (per the Family Educational
                Rights & Privacy Act) (20 U.S.C. Section 1232g, 34 C.F.R. Part
                99)***
              </Grid>
              <Grid item xs={6}>
                Education records directly related to a student maintained by an
                educational institution or party acting on its behalf, such as
                grades, transcripts, class lists, student schedules, student
                identification codes, student financial information, or student
                disciplinary records.
              </Grid>
            </Grid>
            <br />
            <Typography>
              *We may not collect all items listed as examples in a particular
              category.
            </Typography>
            <br />
            <Typography>
              **Not all examples listed in the table above are collected from
              every consumer.
            </Typography>
            <br />
            ***This category of personal information is collected only to the
            extent that it is provided to us as part of an employment
            application with us.
            <br />
            <br />
            <Typography color={theme.palette.text.primary}>
              Please note that personal information does not include:
            </Typography>
            • Publicly available information from government records.
            <br />• De-identified or aggregated consumer information.
            <br />• Information excluded from the CCPA’s scope, like: Personal
            information covered by certain sector-specific privacy laws,
            including the Fair Credit Reporting Act (FRCA), the
            Gramm-Leach-Bliley Act (GLBA) or California Financial Information
            Privacy Act (FIPA), and the Driver’s Privacy Protection Act of 1994.
            <br />
            <br />
            We obtain the categories of personal information listed above from
            the following categories of sources:
            <br />• Directly from you or your authorized agents. For example,
            from documents that our customers provide to us related to the
            products or services for which they engage us.
            <br />• Indirectly from you or your authorized parties. For example,
            through information we collect from our customers (including from
            your employer) in the course of providing products or services to
            them.
            <br />• Directly and indirectly from activity on our websites. For
            example, from submissions through our website portal or website
            usage details that we collect automatically.
            <br />• From third parties that interact with us in connection with
            the services we perform. For example, from credit bureaus when we
            offer or extend credit to you.
            <br />• From third parties who provide us with data used for
            marketing purposes.
            <br />
            <br />{" "}
            <Typography variant="h5" color={theme.palette.text.primary}>
              Use of Personal Information
            </Typography>
            <br /> We may use or disclose the personal information we collect
            for one or more of the following business purposes:
            <br /> • To fulfill or meet the reason for which the information is
            provided. For example, if you share your name and contact
            information to request a financial product, or ask a question about
            or browse our financial products or services, we may use that
            information to respond to your inquiry or to provide you with
            information regarding our products and services.
            <br />• To provide you with information, products or services that
            you request from us.
            <br />• To provide, support, personalize, and develop our websites,
            products, and services.
            <br />• To create, maintain, customize, and secure your account with
            us.
            <br />• To process your requests, purchases, transactions, and
            payments and prevent transactional fraud.
            <br />• To provide you with email alerts, event registrations and
            other notices concerning our products or services, or events or
            news, that may be of interest to you.
            <br />• To carry out our obligations and enforce our rights arising
            from any contracts entered into between you and us, including for
            billing and collections.
            <br />• To improve our website and present its contents to you.
            <br />• To personalize your website experience and to deliver
            content and product and service offerings relevant to your
            interests, including targeted offers and ads through our websites,
            third-party sites, and via email or text message (with your consent,
            where required by law). • For testing, research, analysis and
            product development.
            <br />• For testing, research, analysis and product development.
            <br />• As necessary or appropriate to protect the rights, property
            or safety of us, our customers or others.
            <br />• To respond to law enforcement requests and as required by
            applicable law, court order, or governmental regulations.
            <br />• As described to you when collecting your personal
            information or as otherwise set forth in the CCPA.
            <br />• To evaluate or conduct a merger, divestiture, restructuring,
            reorganization, dissolution, or other sale or transfer of some or
            all of our assets, whether as a going concern or as part of
            bankruptcy, liquidation, or similar proceeding, in which personal
            information held by us is among the assets transferred.
            <br />
            <br />{" "}
            <Typography variant="h5" color={theme.palette.text.primary}>
              Sharing Personal Information
            </Typography>
            <br /> In the preceding twelve (12) months, we have disclosed the
            following categories of personal information to third parties for
            some or all of the business purposes noted above:
            <br />
            <br />• Identifiers
            <br />• California Customer Records personal information categories.
            <br />• Protected classification characteristics under California or
            federal law.
            <br />• Commercial information.
            <br />• Internet or other similar network activity.
            <br />• Geolocation data.
            <br />• Professional or employment-related information.
            <br />
            <br />
            We disclose your personal information for a business purpose to the
            following categories of third parties:
            <br />
            <br />• Our affiliates.
            <br />• Service providers.
            <br />• Third parties to whom you or your agents authorize us,
            directly or indirectly, to disclose your personal information in
            connection with products or services we provide to you.
            <br />• Government or regulatory authorities.
            <br />
            In the preceding twelve (12) months, we have not sold any personal
            information.
            <br />
            <br />
            <Typography variant="h5" color={theme.palette.text.primary}>
              Your Rights and Choices
            </Typography>
            <br />
            The CCPA provides some California residents with specific rights
            regarding their personal information. This section describes your
            CCPA rights and explains how to exercise those rights.
            <br />
            <br />
            Access to Specific Information and Data Portability Rights
            <br />
            <br />
            You have the right to request that we disclose certain information
            to you about our collection and use of your personal information
            over the past 12 months. Once we receive and verify your request, we
            will disclose to you:
            <br />
            <br />• The categories of personal information we collected about
            you.
            <br />• The categories of sources for the personal information we
            collected about you.
            <br />• Our business or commercial purpose for collecting or selling
            (if applicable) that personal information.
            <br />• The categories of third parties with whom we share that
            personal information.
            <br />• The categories of personal information we disclosed or
            shared with a third party for a business purpose.
            <br />• The specific pieces of personal information we collected
            about you (also called a data portability request).
            <br />
            <br />
            Deletion Request Rights
            <br />
            <br />
            You have the right to request that we delete your personal
            information that we collected from you and retained, subject to
            certain exceptions. Once we receive and verify your request, we will
            delete (and direct our service providers to delete) your personal
            information from our records, unless an exception applies, such as
            regulatory obligations or required for servicing the account.
            <br />
            <br />
            If we cannot fulfill your request because an exception applies, we
            will let you know.
            <br />
            <br />
            Exercising Access, Data Portability, and Deletion Rights
            <br />
            <br />
            To exercise the access, data portability, and deletion rights
            described above, please submit your request to us by either:
            <br />
            <br />• Calling us at 866-933-6342
            <br />• Visiting{" "}
            <Link
              href="https://www.homebridge.com/ccpa-vcr-form/"
              target="_blank"
            >
              https://www.homebridge.com/ccpa-vcr-form/
            </Link>
            <br />
            <br />
            Only you, or your authorized agent, may make a verifiable consumer
            request related to your personal information. You may also make a
            verifiable consumer request on behalf of your minor child under age
            18.
            <br />
            <br />
            You may only make a request for access or data portability twice
            within a 12-month period. So that we can verify your request, you
            must:
            <br />
            <br />• Provide sufficient information that allows us to reasonably
            verify you are the person about whom we collected personal
            information or an authorized representative. This includes
            information such as: the last four digits of your loan number, the
            last four digits of your telephone number, your email address, and
            your address.
            <br />• Describe your request with sufficient detail that allows us
            to properly understand, evaluate, and respond to it.
            <br />
            <br />
            We cannot respond to your request or provide you with personal
            information if we cannot verify your identity (or authority to make
            the request) and confirm the personal information relates to you.
            Making a verifiable consumer request does not require you to create
            an account with us.
            <br />
            <br />
            Response and Timing
            <br />
            <br />
            We will respond to a verifiable consumer request within the time
            required by applicable law.
            <br />
            <br />
            Any disclosures we provide will only cover the 12-month period
            preceding receipt of the request. The response we provide will also
            explain the reason(s) we cannot, or will not, comply with a request,
            if applicable. For example, we will not fulfill your request where
            an exception applies, such as where the disclosure of personal
            information would adversely affect the rights and freedoms of
            another consumer or where the personal information that we maintain
            about you is not subject to the CCPA’s access or deletion rights.
            <br />
            <br />
            Non-Discrimination
            <br />
            <br />
            If you are a California resident, you have the right to be free from
            unlawful discrimination for exercising your rights under the CCPA.
            <br />
            <br />
            <Typography variant="h5" color={theme.palette.text.primary}>
              Changes to Our CCPA Privacy Notice
            </Typography>
            <br />
            We reserve the right to amend this CCPA privacy notice at our
            discretion and at any time. When we make changes to this CCPA
            privacy notice, we will post the revised CCPA privacy notice on this
            page with a new “Last updated” date.
            <br />
            <br />
            <Typography variant="h5" color={theme.palette.text.primary}>
              Contact Information
            </Typography>
            <br />
            If you have questions about this notice or the privacy practices of
            Homebridge, please reference our Privacy Policy for information, or
            you can call us at 866-933-6342.
          </Typography>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default CPrivacyDialog;
